import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorProductItemOracleSearch = () => {
  const productItemOracleSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/product/oracle/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { productItemOracleSearch }
}

export default InteractorProductItemOracleSearch
